import {TApiPricingResponse} from '../../../coreGlobal/models/franchise/franchise'
import {removeMonetaryMaskBr} from '../../../utils/formatMonetaryToBr'

export const buildUpdateApiPricingRequest = (data: TApiPricingResponse) => {
  return {
    pricings: {
      ...data.map((item, index) => {
        return {
          endpoint: item.endpoint,
          valid_from: item.validFrom,
          price_per_request: Number(removeMonetaryMaskBr(item.pricePerRequest)),
          notes: item.notes,
        }
      }),
    },
  }
}
